import { Box, Container, Center, Spinner, Alert, AlertIcon, Grid, GridItem } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import { useRecebimentoTroca } from './hooks/useRecebimentoTroca'
import { ConfirmationCard } from './components/ConfirmationCard'
import { SearchForm } from './components/SearchForm'
import { ItemSelector } from './components/ItemSelector'
import { useSearchParams } from 'react-router-dom'

export function RecebimentoTroca() {
  const {
    numNota,
    setNumNota,
    selectedSequence,
    setSelectedSequence,
    pedidoData,
    itemData,
    isLoading,
    isItemLoading,
    isError,
    error,
    isFetching,
    loading,
    handleSearch,
    confirmarRecebimento,
    getItensComTrocasPendentes,
    formatDate,
  } = useRecebimentoTroca()

  const [searchParams] = useSearchParams()
  const paramNumNota = searchParams.get('numNota')

  return (
    <Box bgColor="#313E44" minH="100vh">
      <HeadingPages name={'RECEBIMENTO DE TROCA'} bgColor={'#2484e4'} />

      <Container maxW="container.xl" py={6}>
        {!paramNumNota && <SearchForm numNota={numNota} setNumNota={setNumNota} handleSearch={handleSearch} isLoading={isLoading || isFetching} />}

        {isError && (
          <Alert status="error" mb={6} borderRadius="md">
            <AlertIcon />
            {error?.response?.data?.message || 'Erro ao buscar os dados do pedido'}
          </Alert>
        )}

        {(isLoading || isFetching) && !pedidoData && (
          <Center h="200px">
            <Spinner size="xl" color="#37F091" />
          </Center>
        )}

        {pedidoData && !isLoading && !isFetching && (
          <Grid templateColumns={{ base: '1fr', lg: '1fr 1fr' }} gap={6}>
            <GridItem>
              <ItemSelector
                itensTroca={getItensComTrocasPendentes()}
                selectedSequence={selectedSequence}
                setSelectedSequence={setSelectedSequence}
                isLoading={isLoading || isItemLoading}
              />
            </GridItem>
            <GridItem>
              <ConfirmationCard
                itemData={itemData}
                isItemLoading={isItemLoading && selectedSequence !== ''}
                loading={loading}
                onConfirm={confirmarRecebimento}
                formatDate={formatDate}
              />
            </GridItem>
          </Grid>
        )}
      </Container>
    </Box>
  )
}
